'use client';

import {
	GridToolbarColumnsButton,
	GridToolbarContainer,
	GridToolbarDensitySelector,
	GridToolbarFilterButton,
} from '@mui/x-data-grid-premium';
import React from 'react';

interface CustomToolbarProps {
	customAction?: JSX.Element | JSX.Element[];
	otherItems?: JSX.Element | JSX.Element[];
}

export const CustomToolbar = ({ otherItems, customAction }: CustomToolbarProps) => (
	<GridToolbarContainer>
		<GridToolbarFilterButton onResize={undefined} onResizeCapture={undefined} data-cy='filter-table-button' />
		<GridToolbarColumnsButton onResize={undefined} onResizeCapture={undefined} />
		<GridToolbarDensitySelector onResize={undefined} onResizeCapture={undefined} />
		{otherItems}
		{customAction}
	</GridToolbarContainer>
);
